import styled from 'styled-components';
import { TIPOTEXTO_ENUM } from '../../modules/Helper/tipoTextoEnum';
import { AA_SURFACE } from '~/modules/Helper/contrast.helper';

export const Container = styled.div`
  padding: 0 20px;
  height: 100%;
  background: ${({ fundoTransparente }) =>
    fundoTransparente ? 'transparent' : AA_SURFACE};
  overflow: hidden;
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  word-wrap: break-word;
  white-space: normal;
  width: 100%;
  height: auto;

  /* AccessMonitor justif_txt_02 (AAA 1.4.8) */
  &,
  & * {
    text-align: left !important;
  }

  span {
    ${({ tipoTexto }) =>
      tipoTexto === TIPOTEXTO_ENUM.TITULO &&
      `
        font-size: 1rem;

        @media (max-width: 1024px) {
          font-size: 1.4rem !important;
        }

        @media (max-width: 768px) {
          font-size: 1.2rem !important;
        }

        @media (max-width: 480px) {
          font-size: 1rem !important;
        }
      `}
  }
`;

